"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClientBase = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_better_stacktrace_1 = __importDefault(require("axios-better-stacktrace"));
const utils_1 = require("./utils");
/**
 * `ApiClientBase` is a encapsulation of the network request logic needed to interact with the backend
 * as an authenticated user. It's intended to be as stateless as possible to simplify testing (it
 * only receives a reference to an `AxiosInstance`, which we can mock out later to create a
 * `MockApiClientBase` for testing).
 */
class ApiClientBase {
    constructor({ baseUrl, vgsBaseUrl, userAgent }) {
        this.accessToken = '';
        this.vgsBaseUrl = vgsBaseUrl || '';
        this.client = axios_1.default.create({
            baseURL: baseUrl,
            timeout: 10000,
            headers: Object.assign(Object.assign({ 'Content-Type': 'application/json' }, (userAgent
                ? {
                    'User-Agent': userAgent,
                }
                : {})), utils_1.requestHeaderCacheControlNoStorage),
        });
        (0, axios_better_stacktrace_1.default)(this.client);
        this.client.interceptors.request.use((config) => {
            var _a;
            config.headers = (_a = config.headers) !== null && _a !== void 0 ? _a : {};
            if (this.accessToken) {
                config.headers.authorization = `Bearer ${this.accessToken}`;
            }
            return config;
        });
    }
    /**
     * @param {string} t Token to inject into authorization header.
     */
    setAccessToken(t) {
        this.accessToken = t;
    }
    /**
     * `setRefreshAccessTokenMiddleware` adds response middleware that handles failed requests due
     * to expired tokens by refreshing the token, injecting it, and resubmitting the request.
     * @param {() => Promise<string>} refreshAccessToken Function that returns a new access token.
     */
    setRefreshAccessTokenMiddleware(refreshAccessToken) {
        this.client.interceptors.response.use(undefined, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (error.config && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                const accessToken = yield refreshAccessToken();
                this.setAccessToken(accessToken);
            }
            return Promise.reject(error);
        }));
    }
}
exports.ApiClientBase = ApiClientBase;
